import React, { Fragment, FunctionComponent } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { connect } from "react-redux";
import {
  About,
  AboutTitle,
  AboutText,
  ListWrapper,
  Title,
  TitleColumn,
  List,
  Supplier,
  SupplierColumn,
  ViewJobsLink,
  NoPS,
} from "./styles/psl-styles";

interface ISupplierProps {
  id?: number;
  name?: string;
  createdAt?: string;
  employerId?: number;
  recruiterId?: number;
  activeEngagementCount?: number;
  employer?: {
    name?: string;
    id?: number;
  };
}

export interface IRecruiterPslListProps {
  suppliersList: Array<ISupplierProps>;
  isPortalUser: boolean;
}

export const RecruiterPslList: FunctionComponent<IRecruiterPslListProps> = ({
  suppliersList,
  isPortalUser,
}) => (
  <Fragment>
    <About className="animated fadeInUp delay-1">
      <AboutTitle>About</AboutTitle>
      {isPortalUser ? (
        <AboutText>
          This page shows the PSLs your company are on. The great news is that
          once you gain PSL status, you can automatically engage on any roles
          posted, without any delay, allowing you to crack on with the search.
        </AboutText>
      ) : (
        <AboutText>
          This page shows the PSLs your company are on. PSL status is because
          our clients think you do an amazing job and would welcome a
          longer-term relationship with you. The great news is that once you
          gain PSL status, you can automatically engage on any roles posted,
          without any delay, allowing you to crack on with the search.
        </AboutText>
      )}
    </About>
    <ListWrapper className="animated fadeInUp delay-2">
      {suppliersList.length > 0 && (
        <Title>
          <TitleColumn flex={3}>Employer</TitleColumn>
          <TitleColumn flex={2}>Date Added</TitleColumn>
          <TitleColumn flex={1}>Act. Eng.</TitleColumn>
          <TitleColumn flex={1}>Action</TitleColumn>
        </Title>
      )}
      <List>
        {suppliersList.length > 0 ? (
          suppliersList.map((supplier) => (
            <Supplier key={supplier.id}>
              <SupplierColumn flex={3}>{supplier.employer.name}</SupplierColumn>
              <SupplierColumn flex={2} noMobile>
                {moment(supplier.createdAt).format("MMM Do, YYYY")}
              </SupplierColumn>
              <SupplierColumn flex={1} noMobile>
                {supplier.activeEngagementCount}
              </SupplierColumn>
              <SupplierColumn flex={1} mobileAlignRight>
                <ViewJobsLink
                  href={`/recruiter/jobs?preferred_suppliers&employer_id=${supplier.employer.id}`}
                  title="View jobs"
                >
                  view jobs
                </ViewJobsLink>
              </SupplierColumn>
            </Supplier>
          ))
        ) : (
          <NoPS>There&apos;s no preferred suppliers in your list yet.</NoPS>
        )}
      </List>
    </ListWrapper>
  </Fragment>
);

RecruiterPslList.propTypes = {
  suppliersList: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isPortalUser: PropTypes.bool.isRequired,
};

interface IReduxState {
  preferredSuppliersList: {
    suppliersList: Array<ISupplierProps>;
    isPortalUser: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  suppliersList: state.preferredSuppliersList.suppliersList,
  isPortalUser: state.preferredSuppliersList.isPortalUser,
});

export default connect(mapStateToProps, {})(RecruiterPslList);
